import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentSpecialFreightNotificationsState } from './shipment-special-freight-notifications.state';
import {
  ShipmentSpecialFreightNotificationsLoad,
  ShipmentSpecialFreightNotificationsSetInitialState,
} from './shipment-special-freight-notifications.actions';
import { SpecialFreightIdView } from '../../../../models';
import { LatestNotification } from '../../../monitoring/models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightNotificationsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentSpecialFreightNotificationsState.getLoaded);
  notifications$: Observable<LatestNotification[]> = this.store.select(
    ShipmentSpecialFreightNotificationsState.getNotifications,
  );

  constructor(private store: Store) {}

  loadAll(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightNotificationsLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentSpecialFreightNotificationsSetInitialState());
  }
}
